import { useMemo, useState, useCallback, useEffect } from "react";
import "./comic.css";
import storyBoard from "./panelList.json"

const Comic = ({viewerWidth, viewerHeight}) => {
    const [ zoom, setZoom ] = useState(false);
    const [ pageSelection, setPageSelection ] = useState(0);
    const [ panelSelection, setPanelSelection ] = useState(null);

    const currentPage = useMemo(() => { 
        const availableWidth = viewerWidth - 52;
        const availableHeight = viewerHeight - 114;
        const maxColumns = Math.floor(availableWidth / 320);
        let columns = 1;
        const maxRows = Math.floor(availableHeight / 240);
        let rows = 1;
        let imageUnit = 0;

        if (maxColumns > 3) {
            columns = 3;
        } else {
            columns = maxColumns;
        };
        if (maxRows > 2) {
            rows = 2;
        } else {
            rows = maxRows;
        }
        const panelsPerPage = columns * rows;

        if (Math.floor(availableWidth / (columns * 4)) < Math.floor(availableHeight / (rows * 3))) {
            imageUnit = Math.floor(Math.floor(availableWidth / (columns * 4))) - 2;
        } else {
            imageUnit = Math.floor(Math.floor(availableHeight / (rows * 3))) - 4;
        };
        const comic = [];
        storyBoard.forEach((panel, index) => {
            if (!comic[Math.floor((index)/panelsPerPage)]) {
                comic[Math.floor((index)/panelsPerPage)] = [];
            };
            comic[Math.floor((index)/panelsPerPage)].push(panel);
        });

        return { "panelWidth": imageUnit * 4, "panelHeight": imageUnit * 3, "comic": comic, panelsPerPage }
     }, [viewerWidth, viewerHeight]);

    const panelZoom = (selection) => {
        setPanelSelection(selection);
        setZoom(true);
    };

    const closeZoom = () => {
        setZoom(false);
    };

    // Move to the next image (loops back to the start if at the end)
  const showNext = useCallback(() => {
    setPanelSelection((prevIndex) => 
      prevIndex === null ? null : (prevIndex + 1) % storyBoard.length
    );
  }, []);

  // Move to the previous image (loops to the end if at the start)
  const showPrev = useCallback(() => {
    setPanelSelection((prevIndex) => 
      prevIndex === null ? null : (prevIndex - 1 + storyBoard.length) % storyBoard.length
    );
  }, []);

  // Handle the keyboard events
  useEffect(() => {
    // If the panelZoom isn't open, don't attach the listener
    if (panelSelection === null) return;

    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        showNext();
      } else if (event.key === 'ArrowLeft') {
        showPrev();
      } else if (event.key === 'Escape') {
        closeZoom();
      }
    };

    // Attach listener to the global window object
    window.addEventListener('keydown', handleKeyDown);

    // Clean up the listener when the component unmounts or zoom closes
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [panelSelection, showNext, showPrev]); // Re-run effect only when these dependencies change

    return (
        <div className="comicDiv">
            {!zoom && <>
                <div className="comicNavigation">
                    {pageSelection !== 0 && <button className="arrow-btn-border" onClick={() => setPageSelection(pageSelection - 1)}>&larr;</button>}
                </div>
                <div className="comicLayout">
                    {currentPage["comic"][pageSelection].map((file, index) => 
                            <div key={index} className="comicPanel" onClick={() => panelZoom(pageSelection * currentPage.panelsPerPage + index)}>
                                <img width={currentPage.panelWidth} height={currentPage.panelHeight} alt="Click to enlarge" src={"./comic/" + file} />
                            </div>
                        )
                    }
                </div>
                <div className="comicNavigation">
                    {pageSelection !== currentPage["comic"].length - 1 && <button className="arrow-btn-border" onClick={() => setPageSelection(pageSelection + 1)}>&rarr;</button>}
                </div>
            </>}
            {zoom && <div>
                <div>
                    <span className="close-btn" id="close-btn" onClick={closeZoom}>&times;</span>
                    <img src={"./comic/" + storyBoard[panelSelection]} alt="Full size" />
                </div>
            </div>}
        </div>
    )
}

export default Comic